import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { fromStore } from '../store';
import { ToastService } from '../services/toast.service';
import { LocaleService } from '../services/locale.service';
import { authLocalizedSegments } from '../i18n/route-slugs';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuard {
  constructor(
    private store: Store,
    private router: Router,
    private toastService: ToastService,
    private localeService: LocaleService,
    private translocoService: TranslocoService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.store.select(fromStore.selectAuthUser).pipe(
      map((user) => {
        if (user) {
          if (!this.store.selectSignal(fromStore.selectAuthVendor)()) {
            this.router.navigate(
              authLocalizedSegments('noVendor', this.localeService.locale()),
            );
            return false;
          }
          if (route.data['requiredPermission']) {
            if (
              user.all_permissions.includes(route.data['requiredPermission'])
            ) {
              return true;
            } else {
              this.toastService.error(
                this.translocoService.translate('common.toast.forbidden-page'),
              );
              this.router.navigate(['/']);
              return false;
            }
          } else {
            return true;
          }
        }

        this.router.navigate(
          authLocalizedSegments('login', this.localeService.locale()),
          {
            state: { redirect: state.url },
          },
        );
        return false;
      }),
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
